import React, { useState } from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPaperPlane } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { motion } from "framer-motion";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { UI_AssetMap } from "../components/utils/imageMap";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await emailjs.send(
        "service_ndo77n4",
        "template_d2xk9ia",
        formData,
        "YIq7nbvs7mgGyuR72",
      );

      setSubmitStatus("success");
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error(error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus(null), 5000);
    }
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <div className="min-h-screen overflow-x-hidden bg-[#FFF7F1] ">
      <Header />

      <section className="py-[8%] mt-[12%] md:mt-0 px-[5%] max-w-6xl mx-auto text-center relative z-20">
        {/* Title */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-[2.6rem] md:text-[3.2rem] font-baloo font-bold text-[#2F3E5C] mb-6 "
        >
          Contact-Us
        </motion.h2>

        <p className="text-gray-600 mb-16 text-lg font-baloo font-medium">
          We'd love to hear from you! Send us a message anytime.
        </p>

        {/* CONTACT CARDS */}
        <div className="grid md:grid-cols-2 gap-10 mb-16 max-w-3xl mx-auto items-stretch">
          {/* HEAD OFFICE CARD */}
          <div className="relative flex w-full p-[3px] rounded-3xl bg-gradient-to-r from-orange-300 via-pink-300 to-purple-300">
            {/* CHARACTER */}
            <img
              src={UI_AssetMap.BoyWithLatter_Img}
              alt="boy letter"
              className="
                  absolute
                  -top-[75%]
                  xss:-top-[90%]
                  md:-top-[100%]
                  -left-[5%]
                  w-[30%]
                  md:w-[40%]
                  max-w-[160px]
                  pointer-events-none
                  select-none
                  -z-0
          "
            />

            <div className="flex items-center gap-4 bg-white rounded-3xl p-[6%] shadow-xl w-full z-10">
              <div className="p-[12px] bg-orange-100 rounded-xl text-orange-500">
                <FaMapMarkerAlt size={24} />
              </div>

              <div className="text-left">
                <h3 className=" text-[#2F3E5C] text-lg font-baloo font-semibold">
                  Head Office
                </h3>
                <p className="text-gray-600 text-sm font-baloo font-medium">
                  Rau, Indore, Madhya Pradesh, India - 453331
                </p>
              </div>
            </div>
          </div>

          {/* EMAIL CARD */}
          <div className="mt-[6%] md:mt-0 relative flex w-full p-[3px] rounded-3xl bg-gradient-to-r from-pink-300 via-purple-300 to-blue-300">
            {/* CHARACTER */}
            <img
              src={UI_AssetMap.Envelope_Img}
              alt="mascot letter"
              className="
            absolute
            -top-[55%]
            -right-[8%]
            w-[30%]
            md:w-[35%]
            max-w-[160px]
            pointer-events-none
            select-none
            -z-0
          "
            />

            {/* GRADIENT BORDER */}
            <div className="flex items-center gap-4 bg-white rounded-3xl p-[6%] shadow-xl w-full z-10">
              <div className="p-[12px] bg-pink-100 rounded-xl text-pink-500">
                <FaEnvelope size={24} />
              </div>

              <div className="text-left">
                <h3 className=" text-[#2F3E5C] text-lg font-baloo font-semibold">
                  Email
                </h3>
                <p className="text-gray-600 text-sm font-baloo font-medium">
                  info@twepple.com
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CONTACT FORM */}
        <div className="max-w-3xl mx-auto p-[3px] rounded-[1rem] md:rounded-[2rem] bg-gradient-to-r from-pink-300 via-yellow-300 via-green-300 via-blue-300 to-purple-300">
          <div className="bg-white rounded-[1rem] md:rounded-[2rem] p-[6%] shadow-2xl text-left">
            <form onSubmit={handleSubmit} className="space-y-6">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
                className="w-full border font-baloo font-medium border-gray-300 rounded-xl px-[3%] py-[2%] focus:ring-2 focus:ring-orange-400 outline-none"
              />

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your Email"
                required
                className="w-full border border-gray-300 rounded-xl px-[3%] py-[2%] focus:ring-2 focus:ring-orange-400 outline-none font-baloo font-medium"
              />

              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                required
                className="w-full border font-baloo font-medium border-gray-300 rounded-xl px-[3%] py-[2%] min-h-[180px] focus:ring-2 focus:ring-orange-400 outline-none"
              />

              {submitStatus && (
                <div
                  className={`p-3 rounded-lg text-sm ${
                    submitStatus === "success"
                      ? "bg-green-100 text-green-600"
                      : "bg-red-100 text-red-600"
                  }`}
                >
                  {submitStatus === "success"
                    ? "Message sent successfully!"
                    : "Failed to send message"}
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full font-baloo font-medium bg-[#FF7A30] hover:bg-[#ff6a1c] text-white  py-[3%] rounded-xl flex items-center justify-center gap-2 shadow-md transition"
              >
                {isSubmitting ? (
                  "Sending..."
                ) : (
                  <>
                    <FaPaperPlane />
                    Send Message
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;

// //// pages/ContactPage.jsx
// import React, { useState } from "react";
// import {
//   FaMapMarkerAlt,
//   FaPhone,
//   FaEnvelope,
//   FaPaperPlane,
// } from "react-icons/fa";
// import emailjs from "@emailjs/browser";
// import { motion } from "framer-motion";
// import Header from "../components/Header";
// import Footer from "../components/Footer";

// const ContactPage = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     message: "",
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [submitStatus, setSubmitStatus] = useState(null);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     try {
//       await emailjs.send(
//         "service_ndo77n4", //service ID
//         "template_d2xk9ia", // Templete ID
//         formData,
//         "YIq7nbvs7mgGyuR72" //Public ID
//       );

//       setSubmitStatus("success");
//       setFormData({ name: "", email: "", message: "" });
//     } catch (error) {
//       console.error("Error sending email:", error);
//       setSubmitStatus("error");
//     } finally {
//       setIsSubmitting(false);
//       setTimeout(() => setSubmitStatus(null), 5000);
//     }
//   };

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.1,
//         delayChildren: 0.2,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { y: 30, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: {
//         type: "spring",
//         stiffness: 120,
//       },
//     },
//   };

//   return (
//     <div className="min-h-screen overflow-x-hidden bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900">
//       <Header />

//       <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
//         <motion.h2
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="text-5xl md:text-6xl font-bold text-center mb-16 md:mb-24"
//         >
//           <span className="text-transparent bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text">
//             Let's Create
//           </span>
//           <span className="block mt-4 text-xl md:text-2xl text-gray-300 font-light">
//             Something Amazing Together
//           </span>
//         </motion.h2>

//         <motion.div
//           className="grid md:grid-cols-2 gap-8 lg:gap-16"
//           variants={containerVariants}
//           initial="hidden"
//           animate="visible"
//         >
//           {/* Enhanced Contact Information */}
//           <div className="space-y-6 lg:space-y-8">
//             {[
//               {
//                 icon: <FaMapMarkerAlt className="text-2xl text-cyan-400" />,
//                 title: "Head Office",
//                 content:
//                   "353 Royal Krishna Bunglows, Rau, Indore, Madhya Pradesh, India - 453331",
//                 gradient: "from-cyan-400/10 to-purple-400/10",
//               },
//               // {
//               //   icon: <FaPhone className="text-2xl text-purple-400" />,
//               //   title: "Phone",
//               //   content: "+91 70300 23322",
//               //   gradient: "from-purple-400/10 to-pink-400/10"
//               // },
//               {
//                 icon: <FaEnvelope className="text-2xl text-cyan-400" />,
//                 title: "Email",
//                 content: "info@twepple.com",
//                 gradient: "from-cyan-400/10 to-blue-400/10",
//               },
//             ].map((item, index) => (
//               <motion.div
//                 key={index}
//                 variants={itemVariants}
//                 className="group relative p-6 lg:p-8 bg-gray-800/30 rounded-3xl backdrop-blur-lg
//                   border border-cyan-400/20 hover:border-purple-400/40 transition-all
//                   hover:-translate-y-1 shadow-xl hover:shadow-2xl hover:shadow-purple-500/10"
//               >
//                 <div
//                   className={`absolute inset-0 bg-gradient-to-br opacity-0 group-hover:opacity-100
//                   transition-opacity duration-300 rounded-3xl ${item.gradient}`}
//                 />

//                 <div className="flex items-center gap-5 relative">
//                   <div
//                     className="p-4 bg-gray-900/50 rounded-xl backdrop-blur-sm border
//                     border-cyan-400/20 group-hover:border-purple-400/40 transition-all"
//                   >
//                     {item.icon}
//                   </div>
//                   <div>
//                     <h3
//                       className="text-xl lg:text-2xl font-bold bg-gradient-to-r from-cyan-400
//                       to-purple-400 bg-clip-text text-transparent mb-2"
//                     >
//                       {item.title}
//                     </h3>
//                     <p className="text-gray-100 leading-relaxed text-lg">
//                       {item.content}
//                     </p>
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </div>

//           {/* Enhanced Contact Form */}
//           <motion.div
//             variants={itemVariants}
//             className="relative bg-gray-800/40 p-8 lg:p-12 rounded-[2.5rem] backdrop-blur-lg
//               border border-purple-400/30 hover:border-cyan-400/40 transition-all
//               shadow-2xl hover:shadow-3xl hover:shadow-cyan-500/10"
//           >
//             <div className="absolute -top-8 -right-8 w-32 h-32 bg-purple-400/10 rounded-full blur-3xl" />
//             <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-cyan-400/10 rounded-full blur-3xl" />

//             <form onSubmit={handleSubmit} className="space-y-6 lg:space-y-8">
//               {["name", "email", "message"].map((field, index) => (
//                 <div key={field} className="relative">
//                   <label
//                     className="absolute -top-5 left-4 px-2 bg-gray-800/40 text-sm
//                     text-cyan-300 rounded-full"
//                   >
//                     {field.charAt(0).toUpperCase() + field.slice(1)}
//                   </label>
//                   {field === "message" ? (
//                     <textarea
//                       name={field}
//                       value={formData[field]}
//                       onChange={handleChange}
//                       className="w-full bg-gray-700/20 rounded-xl p-4 pr-6 text-white
//                         placeholder-gray-400/70 focus:ring-2 focus:ring-cyan-400/50
//                         focus:outline-none transition-all min-h-[160px] backdrop-blur-sm
//                         border border-cyan-400/20 hover:border-purple-400/40"
//                       placeholder={`Your ${field}...`}
//                       required
//                     />
//                   ) : (
//                     <input
//                       type={field === "email" ? "email" : "text"}
//                       name={field}
//                       value={formData[field]}
//                       onChange={handleChange}
//                       className="w-full bg-gray-700/20 rounded-xl p-4 pr-6 text-white
//                         placeholder-gray-400/70 focus:ring-2 focus:ring-cyan-400/50
//                         focus:outline-none transition-all backdrop-blur-sm
//                         border border-cyan-400/20 hover:border-purple-400/40"
//                       placeholder={`Your ${field}...`}
//                       required
//                     />
//                   )}
//                   <div className="absolute right-4 top-1/2 -translate-y-1/2 text-cyan-400/80">
//                     {
//                       {
//                         name: "👤",
//                         email: "✉️",
//                         message: "💬",
//                       }[field]
//                     }
//                   </div>
//                 </div>
//               ))}

//               {submitStatus && (
//                 <motion.div
//                   initial={{ opacity: 0, y: 10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   className={`p-4 rounded-xl flex items-center gap-3 backdrop-blur-sm
//                     ${
//                       submitStatus === "success"
//                         ? "bg-green-500/20 text-green-400 border border-green-400/30"
//                         : "bg-red-500/20 text-red-400 border border-red-400/30"
//                     }`}
//                 >
//                   <FaPaperPlane className="flex-shrink-0" />
//                   <span className="text-sm md:text-base">
//                     {submitStatus === "success"
//                       ? "Message launched successfully! 🚀"
//                       : "Launch sequence failed. Retrying..."}
//                   </span>
//                 </motion.div>
//               )}

//               <motion.button
//                 whileHover={{ scale: 1.02 }}
//                 whileTap={{ scale: 0.98 }}
//                 type="submit"
//                 disabled={isSubmitting}
//                 className={`w-full bg-gradient-to-r from-cyan-400 to-purple-400 text-gray-900
//                   px-8 py-4 rounded-xl font-bold transition-all flex items-center justify-center
//                   gap-3 hover:shadow-[0_10px_40px_-15px_rgba(34,211,238,0.5)] relative overflow-hidden
//                   ${isSubmitting ? "opacity-80 cursor-not-allowed" : ""}`}
//               >
//                 <div className="absolute inset-0 bg-white/10 opacity-0 hover:opacity-20 transition-opacity" />
//                 {isSubmitting ? (
//                   <>
//                     <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-900" />
//                     <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-gray-800">
//                       Launching...
//                     </span>
//                   </>
//                 ) : (
//                   <>
//                     <FaPaperPlane className="text-lg animate-pulse" />
//                     <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-gray-800">
//                       Launch Message
//                     </span>
//                   </>
//                 )}
//               </motion.button>
//             </form>
//           </motion.div>
//         </motion.div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default ContactPage;
